import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as KeyConstants from 'Utils/constants/keyConstants';
import MessageView from 'Components/MessageView/MessageView.jsx';
import './MessageDropdown.scss';

class MessageDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedItemText: 'Select Message',
      dropdownListVisible: false,
    };

    this.attachBindings();
  }

  attachBindings() {
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.enableDropDownList = this.enableDropDownList.bind(this);
  }

  componentDidMount() {
    this.setState({
      selectedItemText: this.props.selectedItemText,
    });
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      selectedItemText: newProps.selectedItemText,
    });
  }

  handleOutsideClick(event) {
    if (this.dropDownList && !this.dropDownList.contains(event.target) && this.state.dropdownListVisible) {
      this.toggleDropdown();
    }
  }

  toggleDropdown() {
    this.setState({
      dropdownListVisible: !this.state.dropdownListVisible,
    });
  }
  enableDropDownList = (event) => {
    const eventCode = event.code ? (event.code + "_" + event.ctrlKey) : event.key + "_" + event.ctrlKey;
    if (eventCode == KeyConstants.DOWN_ARROW_BUTTON || eventCode == KeyConstants.DOWN_KEY_CODE_ARROW_BUTTON) {
      this.setState(({
        dropdownListVisible: true,
      }));
      event.preventDefault();
    }
  }
  selectItem(item) {
    this.setState(({
      dropdownListVisible: false,
    }));
    this.props.selectDropdownItem(item);
  }

  render() {
    return (
      <div ref={(ref) => { this.dropDownList = ref; }}>
        <div
          role="button"
          tabIndex='0'
          className="message-dropdown-trigger"
          onClick={this.toggleDropdown}
          onKeyUp={(event) => this.enableDropDownList(event)}
          aria-expanded={this.state.dropdownListVisible}
        >
          <span className="gd-report-runner__filter-toggle">{this.state.selectedItemText}</span>
        </div>

        {this.state.dropdownListVisible ? (<div >
          <ul className="message-dropdown">
            {this.props.dropdownList && this.props.dropdownList.map((item) => {
              return (
                <li id="message-item-id" className="message-item">
                  <MessageView
                    description={item.englishLanguage}
                    primaryAction={() => this.selectItem(item)}
                    primaryActionText="Select"
                    secondaryActionText="View"
                  />
                </li>
              );
            })}
          </ul>
        </div>) : (null)}

      </div>

    );
  }
}
MessageDropdown.propTypes = {
  extraClass: PropTypes.string,
  dropDownList: PropTypes.array.isRequired,
};

MessageDropdown.defaultProps = {
  extraClass: '',
  extraStyle: {},
  dropDownList: [],
  wrapperButtonStyle: {},
};

export function findItem(list, selectedValue) {
  return list.find((item) => item.text === selectedValue);
}

export default MessageDropdown;
